import defaultProfileAsset from "Assets/Images/Profile/default_profile.png";

// CRA / webpack may expose the asset as a string or as { default: string }.
const defaultProfile =
	typeof defaultProfileAsset === "string" ? defaultProfileAsset : defaultProfileAsset?.default || defaultProfileAsset;

/**
 * Returns a usable profile image URL. Users without a real remote profile pic
 * (empty, null, or backend data-URI DummyImage) get the local default_profile.png.
 */
export const resolveProfilePic = (profilePicUrl) => {
	if (profilePicUrl == null) return defaultProfile;
	const url = String(profilePicUrl).trim();
	if (!url || url === "null" || url === "undefined") return defaultProfile;
	// Backend DummyImage is a data URI — prefer the local asset so CSS backgrounds
	// and <img> tags consistently show the default silhouette.
	if (url.startsWith("data:image")) return defaultProfile;
	return url;
};

export { defaultProfile };
